<template>
  <!-- 新版本的名片样式组件 -->
  <div :class="size === 'mini' && 'miniStyle'">
    <a-card
      hoverable
      class="name-card"
      :bodyStyle="{
        padding: 0,
        height: '100%',
        display: 'flex',
        'flex-direction': 'column',
      }"
      @click.self="gotoDetail(data.roleId, data.memunicode)"
    >
      <template v-if="data.contact || visibleMode">
        <div class="topInfo">
          <a-avatar shape="square" :size="80" :src="data.cardAvatar || data.avatar || DEFAULTS_AVATAR_BIG" />
          <div class="topUserInfo">
            <p class="userName">
              {{ data.contact }}
            </p>
            <p class="topUserSubInfo">
              {{ data.companyName }}
            </p>
            <p class="topUserSubInfo">
              {{ data.post }}
            </p>
          </div>
        </div>
        <div class="centerInfo">
          <div v-if="data.phone || data.fixedphone">
            <a-icon type="phone" theme="filled" style="color: #ff6600" />
            <span class="item-text">
              <template v-if="data.phone">{{ data.phonearea + ' ' || '+86 ' }}{{ data.phone }}</template>
              <span v-if="data.phone && data.fixedphone" style="color: #ff6600"> / </span>
              <template v-if="data.fixedphone">{{ data.fixedphone }}</template>
            </span>
          </div>
          <div v-if="data.email">
            <a-icon type="mail" theme="filled" style="color: #ff6600" />
            <span class="item-text">{{ data.email }}</span>
          </div>
          <div v-if="data.address">
            <i class="icon iconfont iconweizhidingwei item-icon" :title="$t('地址')" style="color: #ff6600" />
            <span class="item-text">{{ region }}{{ data.address }}</span>
          </div>
        </div>
        <div class="bottomInfo">
          <div class="btmLeft">
            <i
              v-if="isContactShow"
              class="icon iconfont iconyunmp_icon_qiat"
              style="margin-right: 20px"
              :title="$t('洽谈')"
              @click.stop="toChat(data)"
            />
            <i
              v-if="isShowMode"
              class="icon iconfont iconjiaohuan1"
              style="margin-right: 20px; font-size: 18px"
              :title="$t('交换')"
              @click.stop="getSwapCard(data.memunicode)"
            />
            <i
              v-if="isKeepMode"
              class="icon iconfont iconyunmp_icon_tags"
              :title="$t('企业云展系统')"
              @click.stop="$utils.toInsideLink(`/${data.memunicode}`)"
            />
          </div>

          <ShareLinkTooltip
            :shareType="
              data.companyFlag === System.Identity.Person
                ? System.ShareType.MemberCardShare
                : System.ShareType.MemberCardCompanyShare
            "
            :shareTargetMemberCode="data.memunicode || data.memUnicode"
            :shareParam="data.memunicode || data.memUnicode"
            :placement="placement"
          >
            <i
              v-if="isKeepMode || isShareMode"
              class="icon iconfont iconyunmp_icon_fenx btmRight"
              :title="$t('分享')"
            />
          </ShareLinkTooltip>
        </div>
      </template>
      <div v-else-if="data && Object.keys(data).length" class="emptyBox">
        <v-img :src="EMPTY_CARD_LIST" class="emptyImg" style="width: 200px" />
        <div v-if="isSettingMode" class="userCont empty-content">
          <div style="margin-bottom: 40px">
            {{ $t('请更新名片') }}
          </div>
          <a-button type="primary" size="large" @click.stop="$emit('update')">
            {{ $t('立即更新') }}
          </a-button>
        </div>
      </div>
    </a-card>

    <a-modal
      :width="800"
      :title="$t('修改名片')"
      :visible="cardEditModal"
      :confirm-loading="cardEditModalLoading"
      @ok="cardEditOk"
      @cancel="cardEditCancel"
    >
      <a-form-model ref="cardEditForm" layout="vertical" class="enroll-form" :model="cardEditForm" :rules="rules">
        <a-form-model-item :label="$t('姓名')" prop="contact">
          <a-input v-model.trim="cardEditForm.contact" :placeholder="$t('请填写')" />
        </a-form-model-item>
        <a-row>
          <a-col :span="24" style="color: #999999">
            {{ $t('联系方式（二选一）') }}
          </a-col>
          <a-col :span="11">
            <a-form-model-item :label="$t('手机号')" prop="phone">
              <a-input ref="phone" v-model="cardEditForm.phone" :placeholder="$t('请填写')" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" :offset="1">
            <a-form-model-item :label="`${$t('固定电话')}(xxx-xxxxxxxx)`" prop="fixedphone">
              <a-input ref="fixedphone" v-model="cardEditForm.fixedphone" :placeholder="$t('请填写')" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item :label="$t('邮箱')" prop="email">
          <a-input v-model="cardEditForm.email" :placeholder="$t('请填写')" />
        </a-form-model-item>
        <a-form-model-item :label="$t('岗位名称')" prop="post">
          <a-input v-model="cardEditForm.post" :placeholder="$t('请填写')" />
        </a-form-model-item>
        <a-form-model-item :label="$t('个人简介')" prop="descriptions">
          <a-textarea
            ref="descriptions"
            v-model="cardEditForm.descriptions"
            :auto-size="{ minRows: 3, maxRows: 8 }"
            :placeholder="$t('请填写,最多500字符,若需要换行,请直接回车键输入')"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('个人标签')" prop="tagList" style="margin-bottom: 10px; padding-bottom: 0">
          <a-input
            v-model="tagVal"
            :placeholder="$t('请填写,每个标签最多15个字符,最多20个标签,回车键确定')"
            @pressEnter="addTag"
            @blur="addTag"
          />
        </a-form-model-item>
        <div v-if="tagList" class="tagList">
          <a-tag
            v-for="(item, index) in tagList"
            :key="'tag' + index"
            style="color: #ff6600; border: 1px solid #ff6600"
            closable
            @close="
              (e) => {
                e.preventDefault()
                delTag(index)
              }
            "
          >
            {{ item }}
          </a-tag>
        </div>
      </a-form-model>
    </a-modal>

    <avatarCropper v-if="avatarVisible" ref="avatarCropper" :visible.sync="avatarVisible" @ok="memberAvatarChange" />

    <!-- 如果是子账号点击交换云展 -->
    <!-- <a-modal
      :title="$t('提示')"
      :visible="isShowcallMaster"
      :footer="null"
      @cancel="
        () => {
          isShowcallMaster = false
        }
      "
    >
      <p>
        {{
          $t(
            '企业会员套餐需要企业主账号开通,子账号无权开通！请联系您的企业管理员进行续费或升级,您的企业管理员为:'
          )
        }}
        <span style="color:#FF6600">{{ primaryData.userName }}</span>
      </p>

      <a-radio-group
        v-model="linkLang"
        button-style="solid"
        style="margin-bottom:10px"
        @change="switchLang"
      >
        <a-radio-button value="zh">
          简体中文
        </a-radio-button>
        <a-radio-button value="en">
          English
        </a-radio-button>
      </a-radio-group>

      <NameCardStyle
        v-if="linkLang === 'zh'"
        :data="primaryData"
        :isSettingMode="true"
        size="mini"
      ></NameCardStyle>
      <NameCardStyle
        v-if="linkLang === 'en'"
        :data="primaryData"
        :isSettingMode="true"
        size="mini"
      ></NameCardStyle>
      <div style="display: flex;align-items: center;flex-direction: column;">
        <a-button
          type="primary"
          style="min-width:150px"
          @click="
            () => {
              isShowcallMaster = false
            }
          "
          >{{ $t('确定') }}</a-button
        >
      </div>
    </a-modal> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

// api
import { postSwapCardDispose, putUserInfo } from '@/api/member'
import {
  getSwapCard,
  postUpdateCard,
  // getPrimaryAccount
} from '@/api/memberCenter/namecard'
// components
import ShareLinkTooltip from '@/components/Share/ShareLinkTooltip.vue'
import avatarCropper from '@/components/business/avatarCropper.vue'
// mixins
import { formMixin } from '@/mixin/formRules-mixin'
// utils
import { arrDataJoinString } from '@/utils/data'
// const
import { NAMECARD_BG, NAMECARD_LOGO, DEFAULTS_AVATAR_BIG, EMPTY_CARD_LIST } from '@/const/image'
import { System } from '@/const/constConfig'
// import NameCardStyle from '@/components/website/list/namecardStyle.vue'

export default {
  components: {
    ShareLinkTooltip,
    avatarCropper,
    // NameCardStyle
  },
  mixins: [formMixin],
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    // 显示模式
    isShowMode: {
      type: Boolean,
      default: false,
    },
    // 设置模式
    isSettingMode: {
      type: Boolean,
      default: false,
    },
    // 名片夹模式
    isKeepMode: {
      type: Boolean,
      default: false,
    },
    // 预览模式, 不限制因名称不显示图片
    visibleMode: {
      type: Boolean,
      default: false,
    },
    // 是否显示联系方式, 洽谈按钮
    isContactShow: {
      type: Boolean,
      default: false,
    },
    // 是否只显示分享按钮
    isShareMode: {
      type: Boolean,
      default: false,
    },

    isVisitorHandleTip: {
      type: Boolean,
      default: false,
    },
    logoSize: {
      type: Number,
      default: 75,
    },
    placement: {
      type: String,
      default: 'topLeft',
    },

    // large 大尺寸用于会员后台
    size: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      System,
      DEFAULTS_AVATAR_BIG,
      EMPTY_CARD_LIST,
      NAMECARD_BG,
      NAMECARD_LOGO,
      swapCardLoading: false,
      agreeCardLoading: false,
      rejectCardLoading: false,
      cardEditModal: false,
      cardEditModalLoading: false,
      cardEditForm: {},
      avatarVisible: false,
      avatar: '',
      tagVal: '',
      tagList: [],

      // isShowcallMaster: false,
      // linkLang: 'zh',
      // primaryData: {},
      // zhData: {},
      // enData: {}
    }
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
    region() {
      const { data } = this

      const arr = [
        // data.continentName,
        data.countryName,
        data.stateName,
        data.cityName,
        data.regionName,
      ].filter(Boolean)
      return arrDataJoinString(arr)
    },
    // userContMargin() {
    //   let val = 4
    //   if (this.data.companyName) {
    //     val--
    //   }
    //   if (this.data.phone || this.data.fixedphone) {
    //     val--
    //   }
    //   if (this.data.email) {
    //     val--
    //   }
    //   if (this.data.address) {
    //     val--
    //   }

    //   return `${val}px 0`
    // },
    rules() {
      return {
        contact: this.customRulesString({
          message: this.$t('联系人姓名不能为空'),
          max: 20,
        }),
        phone: this.rulesPhoneNumberOptional,
        fixedphone: this.customRulesString({
          rules: {
            required: false,
          },
          max: 20,
          maxMessage: this.$t('最多填写20个数字'),
        }),
        email: this.rulesEmail,
        post: this.customRulesString({
          message: this.$t('岗位不能为空'),
          max: 30,
        }),
        descriptions: this.customRulesString({
          rules: {
            required: false,
          },
          max: 500,
        }),
      }
    },
  },
  mounted() {
    // 如果子账号, 获取主账号的信息
    // if (this.userInfo.accountLevel === 2 && this.isShowMode) {
    //   this.getAdminAccount()
    // }
  },
  methods: {
    async getSwapCard(id) {
      const that = this
      this.swapCardLoading = true
      const { code, data, msg } = await getSwapCard({ memberUnicode: id })
      this.swapCardLoading = false
      if (code === 0) {
        this.$message.success(data)
      } else if (code === 4001) {
        this.$warning({
          title: this.$t('提示'),
          closable: true,
          maskClosable: true,
          content: this.$t(msg),
          okText: this.$t('去完善名片'),
          onOk: () => {
            that.$router.push(`${this.$store.getters.getConsolePath}/card`)
          },
        })
      } else if (code === 1109 || code === 20008 || code === 20009 || code === 20010 || code === 20011) {
        this.$warning({
          title: this.$t('提示'),
          closable: true,
          maskClosable: true,
          content: this.$t(msg),
          okText: this.$t('去升级'),
          onOk: () => {
            that.$router.push('/upgradevip')
          },
        })
      }
    },
    async handleApply(status, id) {
      const param = {
        id,
        status,
      }
      if (status === 1) {
        this.agreeCardLoading = true
      } else {
        this.rejectCardLoading = true
      }
      const res = await postSwapCardDispose(param)
      this.rejectCardLoading = false
      this.agreeCardLoading = false
      if (res.code === 0) {
        this.$message.success('处理成功')
        this.$emit('updateList')
      }
      console.log('handleApply', param)
    },
    gotoDetail(roleId, id) {
      if (roleId !== 1) {
        if (id) {
          this.$utils.toOuterLink(`/${id}`, false)
        } else {
          this.$message.error('id不存在')
        }
      }
    },
    cardEditOk() {
      this.$refs.cardEditForm.validate(async (valid, object) => {
        console.log('onSubmit', this.cardEditForm)
        if (valid) {
          if (!(this.cardEditForm.phone || this.cardEditForm.email)) {
            return this.$message.error(this.$t('请输入联系方式,手机号/固定电话至少填一个！'))
          }
          // if (!this.cardEditForm.email) {
          //   return this.$message.error(this.$t('请输入联系方式,手机号/固定电话至少填一个！'))
          // }
          this.cardEditForm.tagList = this.tagList
          this.cardEditModalLoading = true
          const res = await postUpdateCard(this.cardEditForm)
          this.cardEditModalLoading = false
          if (res.code === 0) {
            this.cardEditCancel()
            this.$emit('ok')
          }
        } else {
          console.log('error submit!!', object)
        }
      })
    },
    cardEditCancel() {
      this.cardEditModal = false
      this.$refs.cardEditForm.clearValidate()
    },

    async memberAvatarChange(ossUrl) {
      // console.log(ossUrl)
      // 更改会员头像
      const res = await putUserInfo({ avatar: ossUrl })
      if (res.code === 0) {
        this.$store.commit('updateAvatar', ossUrl)
      }
    },
    addTag() {
      console.log('addTag', this.tagVal)
      if (this.tagVal) {
        if (this.tagVal.length > 15) {
          this.$message.error('个人标签请输入15个字以内')
          return
        } else if (this.tagList && this.tagList.length > 20) {
          this.$message.error('您的标签数已超20个, 无法再添加')
          return
        }

        this.tagList.push(this.tagVal)
      }

      this.tagVal = ''
    },
    delTag(index) {
      this.tagList.splice(index, 1)
    },
    // 在线洽谈
    toChat(otherUserData) {
      if (!this.userInfo || !this.userInfo.huanxinId) {
        this.$message.info(this.$t('请登录'))
        this.$store.commit('switchPopupLoginStatus', 'login')
      } else if (this.$store.state.token) {
        this.$store.commit('chat/SWITCH_OTHER_INFO', otherUserData)
        this.$store.commit('chat/switchChatModelShow', true)
      } else {
        this.$message.info(this.$t('请登录'))
        this.$store.commit('switchPopupLoginStatus', 'login')
      }
    },
    // 获取管理员信息
    // async getAdminAccount() {
    //   const { data, code } = await getPrimaryAccount()
    //   if (code === 0) {
    //     this.primaryData = data

    //     this.primaryData.mulLangFieldList.map((item) => {
    //       if (item.langType === 'zh') {
    //         this.zhData = item
    //       } else {
    //         this.enData = item
    //       }
    //     })
    //   }
    // },

    // // 切换管理员的账号语言
    // switchLang(val) {
    //   console.log('val', val.target.value)
    //   if (val.target.value === 'zh') {
    //     this.primaryData = {
    //       ...this.primaryData,
    //       ...this.zhData
    //     }
    //   } else {
    //     this.primaryData = {
    //       ...this.primaryData,
    //       ...this.enData
    //     }
    //   }
    // }
  },
}
</script>
<style lang="scss" scoped>
.miniStyle {
  transform: scale(0.83);
  width: 445.8px;
  height: 266.2px;
  transform-origin: 0 0;
}
// 名片样式
.name-card {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  width: 465px;
  height: 311px;
  padding: 20px 20px 16px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  cursor: auto;

  .topInfo {
    display: flex;
    .topUserInfo {
      margin-left: 16px;
      p {
        margin-bottom: 5px;
      }
      .userName {
        font-size: 18px;
        font-weight: 500;
        max-width: 325px;
        @include text-ellipsis(1);
      }
      .topUserSubInfo {
        color: #666666;
        max-width: 300px;
        @include text-ellipsis(1);
        word-break: break-all;
      }
    }
  }
  .centerInfo {
    // height: 150px;
    flex: 1;
    width: 100%;
    padding-top: 25px;
    border-bottom: 1px solid #f9f9f9;

    > div {
      margin-bottom: 10px;
      display: flex;
    }

    .item-text {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-left: 14px;
      @include text-ellipsis(2);
    }
  }
  .bottomInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    i {
      font-size: 24px;
      cursor: pointer;
    }
    .btmLeft {
      display: flex;
      align-items: center;
    }
    // .btmRight {
    // }
  }

  .emptyBox {
    display: flex;
    justify-content: center;
    align-items: center;
    .emptyImg {
      width: 200px;
      height: 200px;
    }
  }
}
</style>
